import { render, staticRenderFns } from "./compressImg.vue?vue&type=template&id=0de79056&scoped=true&"
import script from "./compressImg.vue?vue&type=script&lang=js&"
export * from "./compressImg.vue?vue&type=script&lang=js&"
import style0 from "./compressImg.vue?vue&type=style&index=0&id=0de79056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de79056",
  null
  
)

export default component.exports